import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, Input, forwardRef, SimpleChanges, OnChanges, OnDestroy, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl,NG_VALUE_ACCESSOR,Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconDeleteChipsComponent } from 'app/icon/components/icon-delete-chips/icon-delete-chips.component';
import _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  standalone: true,
  imports: [IconDeleteChipsComponent,CommonModule,FormsModule,ReactiveFormsModule],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ChipsComponent),
    multi: true,
  }]
})
export class ChipsComponent implements OnInit, OnChanges,OnDestroy {
  destroyRef = inject(DestroyRef)
  @ViewChild('chips') chips: any;
    
  public listSet: any;
  public list: string[] = [];  

  @Input() elementPattern = /.+/;
  @Input() placeholder = "New Element...";
  @Input() required = false;
  @Input() touched = false;
  @Input() idChips: any= '';
  @Input() readonly: boolean = false;
  

  public control: UntypedFormControl = null;
  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};
  public takeUntilSubject: Subject<any> = new Subject();

  constructor() {
    this.control = new UntypedFormControl(this.list, []);
   }

   registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

   writeValue(list: string[]) {
    this.list = list;
  }
  ngOnInit(): void {
    if(this.required) {
      this.control.setValidators([Validators.required]);
    }
    this.list = this.control.value
    
    this.control.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(value=>{
      if(this.required && this.list.length !==0){
        this.control.setErrors(null)
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    const touched = _.get(changes, 'touched.currentValue', this.touched);
    if(touched) {
      this.control.markAsTouched();
    } else {
      this.control.markAsUntouched();
    }
  }
  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  onOptionsSetKeydown() {

    let value = this.listSet.trim()  
    this.listSet = ''
    this.chips.nativeElement.value = ''
    if(value.match(this.elementPattern)) {
      const found = _.find(this.list, (element) => {
        this.listSet = ''
        this.chips.nativeElement.value = ''
        return _.isEqual(_.toLower(element), _.toLower(value));
      }) || false;
      if(found === false) {
        this.list.push(value);
        this.chips.nativeElement.value = ''
      }
    }
    this.onChangeCallback(this.list);
    if (this.listSet == "" || this.listSet == null) return;  
   
    this.listSet = "";   
  }  
  
  dropOption(index: any) { 
    this.cleanInp() 
    this.list.splice(index, 1);  
    this.chips.nativeElement.value = ''
    this.onChangeCallback(this.list);
  }  
  cleanInp(){
    this.listSet = ''
  }

}
